import "../../../FhHelpText.css";
import { computed, openBlock, createBlock, withCtx, renderSlot } from "vue";
import FhText from "../../FhText/FhText.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _sfc_main = {
  __name: "FhHelpText",
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const computedColor = computed(() => {
      return props.disabled ? "disabled" : "subtle";
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(FhText, {
        tag: "span",
        variant: "body-sm",
        weight: "regular",
        color: computedColor.value,
        class: "fh-help-text"
      }, {
        default: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ]),
        _: 3
      }, 8, ["color"]);
    };
  }
};
const FhHelpText = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-b3d3169c"]]);
export {
  FhHelpText as default
};
//# sourceMappingURL=FhHelpText.mjs.map
